/* eslint-disable consistent-return */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { debounce } from '../../api/apiUtils';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import AppCheckBox from '../../shared/components/app-check-box/AppCheckBox';
import AppButton from '../../shared/components/app-button/AppButton';

function PersonalTravelersModal({
  personalTravellers,
  onSelectCustomer,
  totalPax,
}) {
  console.log(personalTravellers);
  const [traverllersList, setTravellersList] = useState(personalTravellers);
  const [searchText, setSearchText] = useState('');
  const [selectedPax, setSelectedPax] = useState([]);

  const setSearchResults = debounce((val) => {
    let data = [...personalTravellers];
    if (val !== '') {
      data = data.filter((o) =>
        Object.keys(o).some(
          (k) =>
            o[k] !== null &&
            o[k] !== undefined &&
            o[k].toString().toLowerCase().includes(val.toLowerCase()),
        ),
      );
    }
    setTravellersList(data);
  }, 500);
  const handleSearch = (event) => {
    const { value } = event.target;
    setSearchText(value);
    setSearchResults(value);
  };
  const handleSelectPassenger = (pax, index) => {
    if (totalPax === selectedPax.length) {
      return false;
    }
    const item = { ...pax, selectedIndex: index };
    setSelectedPax((prev) => {
      if (
        prev.some(
          (x) =>
            `${x.travellerid}_${x.selectedIndex}` ===
            `${pax.travellerid}_${index}`,
        )
      ) {
        return prev.filter(
          (x) =>
            `${x.travellerid}_${x.selectedIndex}` !==
            `${pax.travellerid}_${index}`,
        );
      }
      return [...prev, item];
    });
  };
  return (
    <div>
      <div className="train-search-container">
        <div className="mb-3 d-flex justify-content-end">
          <div style={{ width: '300px' }}>
            <AppTextInput
              value={searchText}
              label="search"
              onChange={handleSearch}
            />
          </div>
        </div>
      </div>
      {traverllersList.length > 0 && (
        <div className="overflow-auto m-2">
          <table className="table table-bordered fs-12 mt-2">
            <thead>
              <tr>
                <th>Select</th>
                <th>Type</th>
                <th>Title</th>
                <th>FirstName</th>
                <th>LastName</th>
                <th>DOB</th>
                <th>Passport</th>
                <th>Pass Exp Date</th>
                <th>Pass Issue Date</th>
                <th>FFN</th>
              </tr>
            </thead>
            {traverllersList.map((pax, index) => (
              <tbody key={index}>
                <tr>
                  <td style={{ textAlign: 'center' }}>
                    <AppCheckBox
                      checked={selectedPax.some(
                        (x) =>
                          `${x.travellerid}_${x.selectedIndex}` ===
                          `${pax.travellerid}_${index}`,
                      )}
                      onChange={() => handleSelectPassenger(pax, index)}
                    />
                  </td>
                  <td>{pax.paxtype}</td>
                  <td>{pax.title}</td>
                  <td>{pax.firstname}</td>
                  <td>{pax.lastname}</td>
                  <td>{pax.dob}</td>
                  <td>{pax.passport}</td>
                  <td>{pax.passportexpiry}</td>
                  <td>{pax.passportissuedate}</td>
                  <td>{pax.frequentflyerno}</td>
                </tr>
              </tbody>
            ))}
          </table>
        </div>
      )}
      {!traverllersList.length > 0 && (
        <div className="text-center fs-4 py-5">No Results Found</div>
      )}
      <div className="d-flex justify-content-center">
        <AppButton
          btnText="Select"
          onClick={() => onSelectCustomer(selectedPax)}
        />
      </div>
    </div>
  );
}

PersonalTravelersModal.propTypes = {
  personalTravellers: PropTypes.array.isRequired,
  onSelectCustomer: PropTypes.func.isRequired,
  totalPax: PropTypes.any.isRequired,
};

export default PersonalTravelersModal;
